module.exports = __webpack_public_path__ + "static/media/venetian.d6597241.obj";